import { TableColumn } from "../pages/ListReceipt";

export const columns: TableColumn[] = [
  { key: "selectAll", header: "Select", isCheckbox: true },
  { key: "voucherNo", header: "Voucher No.", searchable: true },
  { key: "amount", header: "Amount", searchable: true },
  { key: "soldTo", header: "Sold To", searchable: true },
  { key: "issueDate", header: "Issue Date", searchable: true },
  { key: "expiryDate", header: "Expiry Date", searchable: true },
  { key: "createdDate", header: "Created Date", searchable: true },
  { key: "type", header: "Type", filterable: true },
  { key: "remarks", header: "Remarks", searchable: true },
  { key: "voucherUsed", header: "Voucher Used", filterable: true },
  { key: "merchantName", header: "Merchant Name", filterable: true },
  { key: "mode", header: "Mode", filterable: true },
  { key: "isValidated", header: "Is Validated", filterable: true },
];

export const columns1: TableColumn[] = [
  { key: "voucherNo", header: "Voucher No.", searchable: true },
  { key: "amount", header: "Amount", searchable: true },
  { key: "soldTo", header: "Sold To", searchable: true },
  { key: "issueDate", header: "Issue Date", searchable: true },
  { key: "expiryDate", header: "Expiry Date", searchable: true },
  { key: "createdDate", header: "Created Date", searchable: true },
  { key: "type", header: "Type", filterable: true },
  { key: "remarks", header: "Remarks", searchable: true },
  { key: "voucherUsed", header: "Voucher Used", filterable: true },
  { key: "merchantName", header: "Merchant Name", filterable: true },
  { key: "mode", header: "Mode", filterable: true },
  { key: "isValidated", header: "Is Validated", filterable: true },
];

export const metaData = {
  voucherNo: {
    isImage: false,
    linkTo: "",
  },
  amount: {
    isImage: false,
    linkTo: "",
  },
  soldTo: {
    isImage: false,
    linkTo: "",
  },
  issueDate: {
    isImage: false,
    linkTo: "",
  },
  expiryDate: {
    isImage: false,
    linkTo: "",
  },
  createdDate: {
    isImage: false,
    linkTo: "",
  },
  type: {
    isImage: false,
    linkTo: "",
  },
  remarks: {
    isImage: false,
    linkTo: "",
  },
  voucherUsed: {
    isImage: false,
    linkTo: "",
  },
  merchantName: {
    isImage: false,
    linkTo: "",
  },
  mode: {
    isImage: false,
    linkTo: "",
  },
  isValidated: {
    isImage: false,
    linkTo: "",
  },
};
